<template>
  <div>
    <router-view></router-view>
  </div>  
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'Root',

  components: {
    Home
  },

  data: () => ({
  }),

}
</script>
<style>
html{
 /* overflow-y: hidden !important;*/
}
</style>
